export const initialRobotCloudState = {
    robotCatalogByProjectId: {},
    robotCloudProjectSettingsById: {},
    robotStatusByIdByHomeId: {},
    robotsByIdByHomeId: {},
    robotIdsByProjectId: {},
    gatewayCatalogByProjectId: {},
};
